module.exports = __webpack_public_path__ + "img/go_mod_graph.eeda79c9.png";